// extracted by mini-css-extract-plugin
export default {"merch":"Merch_merch__7Hrp0","merchHeader":"Merch_merchHeader__pYGd3","text":"Merch_text__i2dK6"};